import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toggle-wrapper" }
const _hoisted_2 = { class: "toggle" }
const _hoisted_3 = ["checked"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "toggler round" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("input", {
        type: "checkbox",
        checked: this.THEMES.DARK === $setup.theme ? 'checked' : false,
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.toggleTheme && $setup.toggleTheme(...args)))
      }, null, 40, _hoisted_3),
      _hoisted_4
    ])
  ]))
}